import {
  ON_PROVIDER_VALUE_CHANGE,
  ON_PROVIDER_READ,
  ON_PROVIDER_READING,
} from '../actions/types';

const INITIAL_STATE = {
  providers: [],
  loading: false,
  reload: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_PROVIDER_VALUE_CHANGE:
      return { ...state, ...action.payload };
    case ON_PROVIDER_READING:
      return { ...state, loading: true };
    case ON_PROVIDER_READ:
      return {
        ...state,
        providers: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
